<template>
  <div class="groups-page">
    <div class="container">
      <div class="groups-page__header">
        <router-link :to="{ name: 'activity-library-homepage' }" class="d-block groups-page__back-to-activities fs-14"> <img src="static/img/activity-configurator/arrow-left.svg" alt /> Back to Activities </router-link>

        <div class="d-flex justify-content-between align-items-center mt-15">
          <div class="col-md-6">
            <span class="manage-groups-text d-block mb-5">Manage Groups</span>
            <span class="manage-groups-description">Create and edit groups to segment activities in your library.</span>
          </div>
          <div class="col-md-3">
            <div class="">
              <slot></slot>
            </div>
            <div id="datatable_filter" class="dataTables_search">
              <input type="search" id="groupValue" class="form-control form-control-sm act-search" placeholder="Search" aria-controls="datatable" v-model="groupSearch" @keyup.enter="groupSearchFun()" />
            </div>
          </div>
          <button class="groups-page__header__add-tag-btn btn" @click="onClickAddGroups">
            <i class="fa fa-plus-square fs-26 mr-5"></i>
            <span class="group-span">Create Groups</span>
          </button>
        </div>
      </div>

      <ManageGroupsTable v-if="groups" :groups="groups.rows" :count="groups.count" @editGroup="onEditGroup" @deleteGroup="onDeleteGroup" @onSortColumn="onSortColumn" @onPageChange="onPageChange" :pagination="pagination" />
    </div>

    <b-modal ref="addGroupModal" :hide-header="true" :hide-footer="true" size="lg" :body-class="['p-0']" class="add-tag-modal" @hide="onModalClose" scrollable :no-close-on-backdrop="true">
      <div class="add-tag-modal__container pl-20 pr-65 pt-25 pb-25">
        <img src="static/img/add.svg" class="rt-2-10 add-tag-modal__close-icon" @click="closeModal" />
        <div class="row">
          <div class="col-4 pr-0">
            <span class="fs-11 fw-bold color-black">Group Name</span>
          </div>
          <div class="col-8 pl-0">
            <span class="fs-11 fw-bold color-black">Group Description</span>
          </div>
        </div>

        <b-form>
          <div class="row mt-8" v-for="(field, index) in groupsFormFields" :key="index">
            <div class="col-4 pr-0">
              <b-form-input type="text" @input="resetAutoSave" name="tagname" v-model="field.name" class="add-tag-modal__name-input" v-validate="'required'" :state="veeFields.tagname && veeFields.tagname.dirty ? !errors.has('tagname') : null" placeholder="Enter group name" />
            </div>
            <div class="col-7 pl-0">
              <b-form-input type="text" @input="resetAutoSave" name="tagdesc" v-model="field.desc" class="add-tag-modal__desc-input" v-validate="'required'" :state="veeFields.tagdesc && veeFields.tagdesc.dirty ? !errors.has('tagdesc') : null" placeholder="Enter group description" />
            </div>
            <template v-if="index != 0">
              <div class="col-1 pt-2" @click="onRemoveEmptyGroupField(index)">
                <img src="static/img/activity-configurator/delete-tag.svg" class="remove-form-icon" />
              </div>
            </template>
          </div>
        </b-form>

        <div class="row mt-7" v-if="isCreateGroup">
          <div class="col-12">
            <span class="add-tag-modal__add-another-tag" @click="addAnotherTag">Add another group</span>
          </div>
        </div>

        <div class="row mt-14">
          <div class="col-12">
            <button class="primary add-tag-modal__save-tag-btn btn fs-14" v-if="isCreateGroup" @click="postNewGroups(false)">
              Save Groups
            </button>
            <button class="primary add-tag-modal__save-tag-btn btn fs-14" v-else @click="editGroup(false)">
              Save Groups
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ManageGroupsTable from "@/components/activity-library/manage-groups-table";
import swal from "sweetalert2";
import $ from "jquery";

export default {
  name: "ActivityConfiguratorManageGroupspage",
  components: {
    ManageGroupsTable
  },
  data() {
    return {
      groupSearch: null,
      groups: null,
      tagFormField: { name: "", desc: "" },
      groupsFormFields: [{ name: "", desc: "" }],
      isCreateGroup: true, // When the modal opens, we need to know if the modal is opened for creating or editing
      selectedGroup: null,
      errorMsg: null,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        sortOrder: "ASC",
        sortValue: "name",
        search: ""
      },
      pagination: {
        current: 1,
        total: 1
      },
      autoSaveElementTimeout: process.env.VUE_APP_AUTO_SAVE_ELEMENT_LIB_TIMEOUT
    };
  },
  mounted() {
    this.startAutoSave();
  },
  computed: {
    areFieldsValid() {
      return this.groupsFormFields.every(field => field.name && field.desc);
    }
  },
  methods: {
    onClickAddGroups() {
      this.$refs.addGroupModal.show();
    },
    groupSearchFun() {
      const search = $("#groupValue").val();
      this.groupSearch = search;
      this.queryParams = {
        ...this.queryParams,
        search: search
      };
      this.getGroupsList();
    },
    addAnotherTag() {
      this.groupsFormFields.push({ ...this.tagFormField });
    },

    resetModal() {
      this.groupsFormFields = [{ ...this.tagFormField }];
      this.isCreateGroup = true;
      this.selectedGroup = null;
    },

    onModalClose() {
      this.resetModal();
    },

    onEditGroup(tag) {
      this.selectedGroup = tag;
      this.groupsFormFields = [{ name: tag.name, desc: tag.desc }];
      this.isCreateGroup = false;
      this.$refs.addGroupModal.show();
    },

    onSortColumn({ column, order }) {
      const sortValue = column.name;
      this.pagination.current = 1;
      this.queryParams = {
        ...this.queryParams,
        sortValue,
        sortOrder: order,
        pageNum: this.pagination.current
      };
      this.getGroupsList();
    },

    closeModal() {
      this.$refs.addGroupModal.hide();
    },

    onRemoveEmptyGroupField(index) {
      this.groupsFormFields.splice(index, 1);
    },

    // API CALLS

    getGroupsList() {
      this.queryParams.pageNum = this.pagination.current - 1;
      this.$api
        .getGroups(this.queryParams)
        .then(response => {
          this.groups = response.data.result;
          this.pagination.total = Math.floor(this.groups.count / this.queryParams.pageSize) + 1;
        })
        .catch(() => {
          this.$toastr.error("Error while getting groups list");
        });
    },
    validateGroups(tagFormFields, autoSave = false) {
      let isNameValid = true;
      let isDescValid = true;
      for (let i = 0; i < tagFormFields.length; i++) {
        const field = tagFormFields[i];
        if (!field.name) {
          isNameValid = false;
          if (!autoSave) {
            this.errorMsg = "Name is required.";
          }
          break;
        }
        if (!field.desc) {
          isDescValid = false;
          if (!autoSave) {
            this.errorMsg = "Description is required.";
          }
          break;
        }
      }
      if (isNameValid && isDescValid) {
        if (!autoSave) {
          this.errorMsg = "";
        }
        return true;
      }
      return false;
    },
    postNewGroups(autoSave = false) {
      const isValid = this.validateGroups(this.groupsFormFields, autoSave);
      if (isValid) {
        this.$api
          .createGroups(this.groupsFormFields)
          .then(response => {
            if (response.data.result instanceof Array) {
              const message = response.data.result.join("</br>");
              if (!autoSave) {
                this.$toastr.error(message);
              }
            } else {
              if (!autoSave) {
                this.$toastr.success("Groups created successfully");
              }
              this.$refs.addGroupModal.hide();
              this.getGroupsList();
            }
          })
          .catch(() => {
            if (!autoSave) {
              this.$toastr.error("Unable to create new groups");
            }
          });
      } else {
        if (!autoSave) {
          this.$toastr.error(this.errorMsg);
        }
      }
    },
    editGroup(autoSave = false) {
      const isValid = this.validateGroups(this.groupsFormFields, autoSave);
      if (isValid) {
        const tagId = this.selectedGroup.id;
        this.$api
          .modifyGroup(tagId, this.groupsFormFields[0])
          .then(() => {
            if (!autoSave) {
              this.$toastr.success("Group updated successfully");
            }
            this.$refs.addGroupModal.hide();
            this.getGroupsList();
          })
          .catch(error => {
            if (error.data.result) {
              if (!autoSave) {
                this.$toastr.error(error.data.result);
              }
            } else {
              if (!autoSave) {
                this.$toastr.error("Unable to modify group");
              }
            }
          });
      } else {
        if (!autoSave) {
          this.$toastr.error(this.errorMsg);
        }
      }
    },

    onDeleteGroup(group) {
      const isGroupAssociatedWithAnActivity = group.activity_count && group.activity_count > 0;
      let warningText = "";
      if (isGroupAssociatedWithAnActivity) {
        warningText = "This group is currently associated with existing activities. Are you sure you want to remove this group and any associations?";
      } else {
        warningText = "Are you sure you want to delete this group?";
      }
      swal({
        title: warningText,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        confirmButtonText: "Cancel",
        cancelButtonText: "Delete"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.$api
            .deleteGroup(group.id)
            .then(() => {
              this.$toastr.success("Group deleted successfully");
              this.getGroupsList();
            })
            .catch(() => {
              this.$toastr.error("Unable to delete the group");
            });
        }
      });
    },

    onPageChange(direction) {
      if (this.pagination.current === 1 && direction === -1) {
        return;
      }

      if (this.pagination.current === this.pagination.total && direction === 1) {
        return;
      }

      this.pagination.current += direction;

      this.getGroupsList();
    },
    startAutoSave() {
      this.autoSaveTimer = setInterval(() => {
        this.isCreateGroup ? this.postNewGroups(true) : this.editGroup(true);
      }, this.autoSaveElementTimeout);
    },
    stopAutoSave() {
      clearInterval(this.autoSaveTimer);
    },
    resetAutoSave() {
      this.stopAutoSave();
      this.startAutoSave();
    }
  },
  beforeDestroy() {
    this.stopAutoSave();
  },
  created() {
    this.getGroupsList();
  }
};
</script>

<style scoped lang="scss">
.groups-page {
  font-family: "RobotoRegular";

  &__back-to-activites {
    color: #4c8ce4;
  }

  .container {
    max-width: 90%;
  }

  &__header {
    /* max-width: 90%; */
    margin: 100px auto 0 auto;

    &__add-tag-btn {
      height: 35px;
      border-radius: 4px;
      background-color: #4c8ce4;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: #ffffff;
      padding: 3px 5px;
    }
  }

  .manage-groups-text {
    /* width: 105px; */
    height: 24px;
    font-family: "RobotoRegular";
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    color: #000000;
  }

  .manage-groups-description {
    font-family: "RobotoRegular";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.71;
    letter-spacing: normal;
    color: #000000;
  }

  .add-tag-modal {
    .modal-dialog {
      vertical-align: top !important;
      top: 100px;
    }

    &__container {
      width: 902px;
      height: auto;
      border-radius: 4px;
      background-color: #ffffff;
      overflow: auto;
      position: relative;

      .fw-bold {
        font-weight: bold;
      }

      .color-black {
        color: black;
      }
    }

    &__name-input {
      width: 220px;
      height: 35px;
      border-radius: 3px;
      border: solid 1px #d3dfe4;
    }

    &__desc-input {
      width: 100%;
      height: 35px;
      border-radius: 3px;
      border: solid 1px #d3dfe4;
    }

    &__add-another-tag {
      font-family: "RobotoRegular";
      font-size: 12px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.67;
      letter-spacing: normal;
      color: #4c8ce4;
      cursor: pointer;
    }

    &__save-tag-btn {
      width: 110px;
      height: 35px;
      border-radius: 4px;
      background-color: #4c8ce4;
      color: white;
    }

    &__close-icon {
      position: absolute;
      right: 10px;
      top: 10px;
      cursor: pointer;
    }
  }
}

.group-span {
  position: relative;
  top: -5px;
}
.modal-dialog {
  max-height: auto !important;
}
.remove-form-icon {
  cursor: pointer;
  height: 28px;
}
.dataTables_search input {
  width: 96%;
  height: 36px;
  background-image: url(/static/img/activity-configurator/activity-library-search.svg) !important;
  background-position: right 2% top 80% !important;
  background-repeat: no-repeat;
  background-size: 26px 27px;
  border-radius: 0.2rem;
}
#datatable_filter.dataTables_search {
  position: relative;
  left: 38%;
}
</style>
